import classnames from "classnames";
import React from "react";
import { PrismicPopin } from "src/components";
import theme from "src/theme";
import styled from "styled-components";

import { Slice } from "../components";
import { ISliceModal } from "../types";

const PopinButton = styled(PrismicPopin)`
  border: 1px solid ${theme.colors.black};
  background-color: ${theme.colors.black};
  color: ${theme.colors.white};
  font-family: ${theme.fonts.granville};
  font-size: ${theme.fontSizes.medium};

  &:hover {
    background-color: transparent;
    color: ${theme.colors.black};
  }
`;

export const Modal = ({
  slice_type,
  primary,
  items,
}: ISliceModal): JSX.Element | null => {
  const { class_name: className } = primary;

  return (
    <Slice className={classnames("slice-modal", className)} noGutter>
      <PopinButton data={primary} background="rgba(0, 0, 0, 0.3)" />
    </Slice>
  );
};
